/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CurrencyAmount } from './CurrencyAmount';
import {
    CurrencyAmountFromJSON,
    CurrencyAmountFromJSONTyped,
    CurrencyAmountToJSON,
    CurrencyAmountToJSONTyped,
} from './CurrencyAmount';

/**
 * 
 * @export
 * @interface RawRateSummaryCharge
 */
export interface RawRateSummaryCharge {
    /**
     * 
     * @type {string}
     * @memberof RawRateSummaryCharge
     */
    name: string;
    /**
     * 
     * @type {CurrencyAmount}
     * @memberof RawRateSummaryCharge
     */
    value: CurrencyAmount;
}

/**
 * Check if a given object implements the RawRateSummaryCharge interface.
 */
export function instanceOfRawRateSummaryCharge(value: object): value is RawRateSummaryCharge {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function RawRateSummaryChargeFromJSON(json: any): RawRateSummaryCharge {
    return RawRateSummaryChargeFromJSONTyped(json, false);
}

export function RawRateSummaryChargeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RawRateSummaryCharge {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': CurrencyAmountFromJSON(json['value']),
    };
}

export function RawRateSummaryChargeToJSON(json: any): RawRateSummaryCharge {
    return RawRateSummaryChargeToJSONTyped(json, false);
}

export function RawRateSummaryChargeToJSONTyped(value?: RawRateSummaryCharge | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'value': CurrencyAmountToJSON(value['value']),
    };
}

